import moment from 'moment';

import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USER_ID,
  USER_EMAIL,
  USER_EXPIRATION,
  EMPLOYEE_ID,
  MATRIX_ID,
  COMPANY_IDS,
  MODULE,
  USER_NAME,
  IS_MASTER_PASSWORD_AUTHENTICATION,
} from './constants';

import getUserDataFromToken from './getUserDataFromToken';

const saveUserDataInLocalStorage = (accessToken, refreshToken) => {
  if (!accessToken || !refreshToken)
    throw new Error('Informações inválidas do usuário.');

  const user = getUserDataFromToken(accessToken);

  if (!user) throw new Error('Não foi possível identificar o usuário logado.');

  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
  localStorage.setItem(USER_ID, user.userId);
  localStorage.setItem(USER_EMAIL, user.email);
  localStorage.setItem(USER_NAME, user.username);
  localStorage.setItem(USER_EXPIRATION, moment.unix(user.exp).toISOString());
  localStorage.setItem(EMPLOYEE_ID, user.employeeId);
  localStorage.setItem(MATRIX_ID, user.matrixId);
  localStorage.setItem(COMPANY_IDS, user.companyIds);
  localStorage.setItem(MODULE, user.module);
  localStorage.setItem(
    IS_MASTER_PASSWORD_AUTHENTICATION,
    user.is_master_password_authentication,
  );
};

export default saveUserDataInLocalStorage;
